import api from './axios';

// channel is optional: omitted (not sent blank) for All Channels.
export const getAnalysis = (month, dimension, channel) =>
  api.get('/analysis', { params: { month, dimension, ...(channel ? { channel } : {}) } }).then((r) => r.data);
// Same parameters as getAnalysis, so the workbook is built from exactly the report on
// screen (dimension = active tab, whose sheet the search narrows, as on screen).
export const exportAnalysisExcel = async ({ month, dimension, channel, search }) => {
  const params = { month, dimension, ...(channel ? { channel } : {}), ...(search?.trim() ? { search: search.trim() } : {}) };
  const response = await api.get('/analysis/export', { params, responseType: 'blob' });
  const fromHeader = /filename="([^"]+)"/.exec(response.headers?.['content-disposition'] || '')?.[1];
  const slug = (channel || '').trim().replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const filename = fromHeader || `GP_Analysis_${month}${slug ? `_${slug}` : ''}.xlsx`;
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
export const getReportRecipients = () => api.get('/analysis/recipients').then((r) => r.data);
export const saveReportRecipients = (recipients, cc) => api.put('/analysis/recipients', { recipients, cc }).then((r) => r.data);
export const emailReport = (month, to, cc) => api.post('/analysis/email', { month, to, cc }).then((r) => r.data);
